@if (isActivityLoaded) {

<!-- ── Modal Header ── -->
<div class="activity-modal-header">
  <div class="activity-header-icon-box">
    <ion-icon name="flash-outline"></ion-icon>
  </div>
  <div class="activity-header-copy">
    <ion-text class="activity-header-kicker">{{ data.type ? 'Update' : 'New' }}</ion-text>
    <h2 class="activity-header-title">{{ data.type ? 'Update Activity' : 'Create Activity' }}</h2>
  </div>
  <button class="activity-close-btn" (click)="closeDialog()" aria-label="Close dialog">
    <ion-icon name="close-outline"></ion-icon>
  </button>
</div>

<!-- ── Modal Body ── -->
<div class="activity-modal-body">
  <form name="registerForm" [formGroup]="registerForm" novalidate>

    <!-- Activity Type -->
    <ion-card class="activity-field-card">
      <ion-card-content>
        <div class="field-row-header">
          <div class="field-icon-box">
            <ion-icon name="options-outline"></ion-icon>
          </div>
          <ion-text class="field-label">Activity Type</ion-text>
          <div class="field-quick-link" (click)="goToCustomActivites('Activity')" role="button" tabindex="0"
            (keydown.enter)="goToCustomActivites('Activity')">
            <ion-icon name="list-circle-outline"></ion-icon>
            <span>Your Activities</span>
          </div>
        </div>
        <mat-form-field appearance="outline">
          <mat-select [(ngModel)]="regReq.ActivityType" formControlName="ActivityType"
            (selectionChange)="onSelectEvent($event.value)" placeholder="Select Activity Type">
            @for (item of activityTypeList; track item) {
            <mat-option [value]="item.name">{{ item.name }}</mat-option>
            }
          </mat-select>
          <mat-error>Activity type is required</mat-error>
        </mat-form-field>
      </ion-card-content>
    </ion-card>

    <!-- Detail Fields (shown after type is selected) -->
    @if (isType) {
    <ion-card class="activity-field-card">
      <ion-card-content>

        <!-- Date -->
        <div class="field-row-header">
          <div class="field-icon-box">
            <ion-icon name="calendar-outline"></ion-icon>
          </div>
          <ion-text class="field-label">Activity Date</ion-text>
        </div>
        <mat-form-field appearance="outline">
          <input matInput readonly [(ngModel)]="regReq.DtDate" [matDatepicker]="dp3" [min]="minDate"
            placeholder="Select Date" formControlName="DtDate">
          <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
          <mat-datepicker #dp3></mat-datepicker>
        </mat-form-field>

        <!-- Time -->
        <div class="field-row-header">
          <div class="field-icon-box">
            <ion-icon name="time-outline"></ion-icon>
          </div>
          <ion-text class="field-label">Activity Time</ion-text>
        </div>
        <mat-form-field appearance="outline">
          <mat-select [(ngModel)]="regReq.DtTime" formControlName="DtTime"
            placeholder="Select Time  e.g. 12:00 AM">
            @for (item of timeList; track item) {
            <mat-option [value]="item.name">{{ item.name }}</mat-option>
            }
          </mat-select>
          <mat-error>Activity time is required</mat-error>
        </mat-form-field>

        <!-- Comment -->
        <div class="field-row-header">
          <div class="field-icon-box">
            <ion-icon name="chatbox-ellipses-outline"></ion-icon>
          </div>
          <ion-text class="field-label">Comment</ion-text>
        </div>
        <mat-form-field appearance="outline">
          <textarea matInput [(ngModel)]="regReq.CommentBox" formControlName="CommentBox"
            placeholder="Enter a note about this activity" rows="3"></textarea>
          <mat-error>Activity comment is required</mat-error>
        </mat-form-field>

        <!-- Lead Status -->
        <div class="field-row-header">
          <div class="field-icon-box">
            <ion-icon name="trending-up-outline"></ion-icon>
          </div>
          <ion-text class="field-label">Lead Status</ion-text>
        </div>
        <mat-form-field appearance="outline">
          <mat-select [(ngModel)]="regReq.LeadStatus" formControlName="LeadStatus"
            placeholder="Select Lead Status">
            @for (item of leadStatusList; track item) {
            <mat-option [value]="item.name">{{ item.name }}</mat-option>
            }
          </mat-select>
          <mat-error>Lead status is required</mat-error>
        </mat-form-field>

      </ion-card-content>
    </ion-card>
    }

    <!-- Footer Actions -->
    <div class="activity-footer">
      <div class="custom-list-pill" (click)="goToCustomActivites('Activity')" role="button" tabindex="0"
        (keydown.enter)="goToCustomActivites('Activity')">
        <ion-icon name="apps-outline"></ion-icon>
        <span>Custom List</span>
      </div>
      <div class="footer-btn-group">
        <ion-button fill="outline" class="btn-cancel" (click)="closeDialog()">
          <ion-icon name="close-circle-outline" slot="start"></ion-icon>
          Close
        </ion-button>
        <ion-button [disabled]="!registerForm.valid" (click)="attemptRegister()" class="btn-submit">
          <ion-icon name="checkmark-circle-outline" slot="start"></ion-icon>
          {{ data.type ? 'Update' : 'Submit' }}
        </ion-button>
      </div>
    </div>

  </form>
</div>

}